import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useId } from 'react';
import { Slot } from '@radix-ui/react-slot';
import styles from './GridItem.styles.esm.js';

const GridItem = forwardRef((props, forwardRef) => {
    var _a, _b;
    const generatedId = useId();
    const { id = generatedId, className, asChild = false, colSpan = 1, rowSpan = 1 } = props, otherProps = __rest(props, ["id", "className", "asChild", "colSpan", "rowSpan"]);
    const Comp = asChild ? Slot : "div";
    const styleOptions = {
        class: className,
        xsColSpan: typeof colSpan === "number" ? colSpan : ((_a = colSpan === null || colSpan === void 0 ? void 0 : colSpan.xs) !== null && _a !== void 0 ? _a : 12),
        smColSpan: typeof colSpan !== "number" ? colSpan === null || colSpan === void 0 ? void 0 : colSpan.sm : undefined,
        mdColSpan: typeof colSpan !== "number" ? colSpan === null || colSpan === void 0 ? void 0 : colSpan.md : undefined,
        lgColSpan: typeof colSpan !== "number" ? colSpan === null || colSpan === void 0 ? void 0 : colSpan.lg : undefined,
        xsRowSpan: typeof rowSpan === "number" ? rowSpan : ((_b = rowSpan === null || rowSpan === void 0 ? void 0 : rowSpan.xs) !== null && _b !== void 0 ? _b : 1),
        smRowSpan: typeof rowSpan !== "number" ? rowSpan === null || rowSpan === void 0 ? void 0 : rowSpan.sm : undefined,
        mdRowSpan: typeof rowSpan !== "number" ? rowSpan === null || rowSpan === void 0 ? void 0 : rowSpan.md : undefined,
        lgRowSpan: typeof rowSpan !== "number" ? rowSpan === null || rowSpan === void 0 ? void 0 : rowSpan.lg : undefined,
    };
    const classNames = styles(styleOptions);
    return (jsx(Comp, Object.assign({ id: id, ref: forwardRef, className: classNames }, otherProps)));
});
GridItem.displayName = "GridItem";

export { GridItem };
